var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrices(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5744 22C13.2993 22 12.0279 21.5719 10.9944 20.7945L10.9198 20.7346C10.2897 20.1954 9.46339 19.9489 8.65263 20.0582C8.46874 20.0831 8.28367 20.1274 8.10224 20.1899C8.03628 20.2183 7.96952 20.2456 7.90338 20.2715L7.81489 20.306C7.45504 20.475 7.12766 20.7192 6.86265 21.0172L6.22388 21.7355L4 19.6231L4.63877 18.9049C5.28669 18.1765 6.10606 17.6142 7.01014 17.2773C8.2664 16.7038 9.10849 15.3717 9.10849 13.953C9.10849 13.8745 9.10607 13.7961 9.10123 13.7181H5.13439V10.5966H7.76439C7.45043 9.8359 7.28672 9.01098 7.28672 8.17324C7.28672 4.7693 9.9665 2 13.2603 2C14.5527 2 15.783 2.41984 16.8183 3.2141C17.832 3.99176 18.5698 5.05719 18.9521 6.29523L16.0745 7.24406C15.6825 5.97445 14.5516 5.12144 13.2603 5.12144C11.632 5.12144 10.3072 6.49047 10.3072 8.17324C10.3072 8.84094 10.5144 9.57953 11.2797 10.5966H16.0845V13.7181H12.125C12.1277 13.7964 12.129 13.8747 12.129 13.953C12.129 15.1578 11.8243 16.3209 11.2435 17.3493C11.8049 17.5796 12.3307 17.8972 12.8036 18.2943C13.4257 18.7497 14.2022 18.9538 14.9385 18.8543C15.762 18.7432 16.5066 18.2748 16.9812 17.5693L17.5201 16.7684L20 18.5504L19.4612 19.3513C18.5016 20.7775 16.9958 21.7245 15.3297 21.9495C15.0815 21.983 14.8274 22 14.5744 22Z",
    fill: "#8B857E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrices);
export default __webpack_public_path__ + "static/media/Prices.6fc5c17d3d1a4b521aa83b436a02dcb4.svg";
export { ForwardRef as ReactComponent };